import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
    TextField,
    withStyles,
    Button,
    CircularProgress,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from '@material-ui/core';

const styles = (theme) => ({
    btn: { textAlign: 'right', marginLeft: '50%', marginBottom: '0.5rem' },
    formControl: {
        marginTop: theme.spacing(3),
        width: '100%',
        marginBottom: '5px',
    },
    dialogPaper: {
        margin: theme.spacing(2),
        padding: theme.spacing(2),
        minHeight: '15vh',
        minWidth: '70vh',
    },
    submit: {
        width: '100%',
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default,
        },
        marginTop: '5px',
    },
});

const AndroidSetupForm = (props) => {
    const { classes, formSettings, initialValues, handleSubmit, translations, wifis } = props;

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
                setSubmitting(false);
            }}
            validationSchema={Yup.object().shape(formSettings.Validation)}
        >
            {(formikProps) => {
                const { values, isValid, isSubmitting, handleChange, handleBlur, handleSubmit, errors, touched } =
                    formikProps;

                return (
                    <form onSubmit={handleSubmit} autoComplete="off">
                        <FormControl className={classes.formControl}>
                            <TextField
                                label={translations['send_qr_text'] || 'Please enter email for sending QR code'}
                                placeholder={translations['email'] || 'Email'}
                                name="Email"
                                fullWidth={true}
                                value={values.Email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                margin="dense"
                                error={!!(errors.Email && touched.Email)}
                                autoFocus={true}
                            />
                        </FormControl>
                        <FormControl className={classes.formControl}>
                            <InputLabel shrink>
                                {translations['select_wifi'] || 'Please select wifi name/SSID'}
                            </InputLabel>
                            <Select
                                name="Wifi"
                                placeholder={translations['wifi'] || 'Wifi'}
                                margin={'dense'}
                                value={values.Wifi}
                                onChange={handleChange}
                                disabled={!wifis}
                            >
                                {(wifis ? [...wifis] : []).map((option) => (
                                    <MenuItem key={option.SSID} value={option}>
                                        {option.SSID}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {formSettings.ButtonSubmit ? (
                            <Button
                                className={classes.submit}
                                variant="contained"
                                color={formSettings.ButtonSubmit.Color}
                                type="submit"
                                fullWidth={true}
                                disabled={isSubmitting || !isValid}
                            >
                                {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                            </Button>
                        ) : null}
                    </form>
                );
            }}
        </Formik>
    );
};

export default withStyles(styles, { withTheme: true })(AndroidSetupForm);
